import { getUserSettings } from "@library/Services/UserSettings";
import { UserSettings } from "./UserSettings";

/**
 * User settings are bound o the appVehicleId in the query string, so each vehicle
 * has its own set of user settings
 * @returns 
 */
export function useUserSettings()
{
    const urlParams = new URLSearchParams( window.location.search );
    const appVehicleId = urlParams.get( 'appVehicleId' );
    const store = getUserSettings( UserSettings, `userSettings:${appVehicleId}` );
    return store.instance as UserSettings;
}
